import { APP_VERSION, COUNTRY_CODE, EnvironmentType } from "./environment.type";

export const environment: EnvironmentType = {
  placement: "prod",
  production: true,
  route_hash: false,
  timezone: "America/Paramaribo",
  code: COUNTRY_CODE.br,
  currency: "BRL",
  grammar: "pt-BR",
  lang: "pt",
  phone_length: 10,
  max_phone_length: 11,
  max_tip: 0,
  phone_prefix: "+55",
  gateway: {
    base_url: "https://services.rappi.com.br",
    location_gateway_prefix: "/api/cargo-api-gateway/core-maps/address/",
    csv_prefix: "/api/cargo-api-gateway/csv/portal/",
    gateway_prefix: "/api/cargo-api-gateway/portal/",
    settlement_prefix: "/api/cargo-api-gateway/portal/settlement/",
  },
  logoUrl: "https://cargo-core-api.s3.us-west-2.amazonaws.com/br/cargo-logos/",
  trackingUrl: "cargo-tracking.rappi.com.br/",
  maps_api: {
    api_key: "AIzaSyAkV5IitnHrf97H_nLDUJ4TBMeZwGdFa0Y",
  },
  coordsCenter: { lat: -15.77972, lng: -47.92972 },
  currencySymbol: "R$",
  decimalPattern: /^[0-9]+([.]\d{0,1})?$/,
  decimalNumber: 2,
  country: {
    defaultLocale: "pt-BR",
  },
  localeUrl: "https://cargo-core-api.s3.amazonaws.com/br/cargo-logos/",
  auth0: {
    client_id: "hDcAOaY9heMYiAxYPvr5Ynt3ZeNybA43",
    client_secret: "OxnMGuC8OXHjYTgznaaKL2ItdOB4xdMj2jpTDbx6au00NQX47lBEdjgGXc6ia2m4",
    domain: "https://login.partners.rappi.com",
  },
  amplitude: {
    key: "032f00f0dfdad881e7391f28f35156f6",
  },
  OAuthGateway: "https://www.rappi.com.br/login-legacy/signup",
  i18n_version: APP_VERSION,
  kustomer_assistant_id: "664bbe3419e7a2316b52dc7a",
};
